var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeBuildingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80156 4.7999C4.80156 3.47442 5.87608 2.3999 7.20156 2.3999H16.8016C18.127 2.3999 19.2016 3.47442 19.2016 4.7999V19.1999C19.8643 19.1999 20.4016 19.7372 20.4016 20.3999C20.4016 21.0626 19.8643 21.5999 19.2016 21.5999H15.4016C14.8493 21.5999 14.4016 21.1522 14.4016 20.5999V17.9999C14.4016 17.3372 13.8643 16.7999 13.2016 16.7999H10.8016C10.1388 16.7999 9.60156 17.3372 9.60156 17.9999V20.5999C9.60156 21.1522 9.15385 21.5999 8.60156 21.5999H4.80156C4.13882 21.5999 3.60156 21.0626 3.60156 20.3999C3.60156 19.7372 4.13882 19.1999 4.80156 19.1999V4.7999ZM8.40156 5.9999H10.8016V8.3999H8.40156V5.9999ZM10.8016 10.7999H8.40156V13.1999H10.8016V10.7999ZM13.2016 5.9999H15.6016V8.3999H13.2016V5.9999ZM15.6016 10.7999H13.2016V13.1999H15.6016V10.7999Z",
    fill: "#4FC0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeBuildingIcon);
export default __webpack_public_path__ + "static/media/office-building-icon.cac26310212825f1e8ab40ede566b450.svg";
export { ForwardRef as ReactComponent };